// ----------------------------------------------------------------------

export default function FormControlLabel(theme) {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontSize: "16px !important",
        },
      },
    },
  };
}
